angular.module('unica.snippets_directive', [])

.directive('invitationStatus', function() {
	return {
		transclude: true,
		scope: {
			invitation: '='
		},
		templateUrl: './templates/snippets/invitation-status.html',
		replace: true,
		restrict: 'E',

		link: function($scope, element, attrs) {
		}
	}
})

.directive('mailgunStatus', function() {
	return {
		transclude: true,
		scope: {
			invitation: '='
		},
		templateUrl: './templates/snippets/mailgun-status.html',
		replace: true,
		restrict: 'E',

		link: function($scope, element, attrs) { }
	}
})

.directive('mailgunConfirmationStatus', function() {
	return {
		transclude: true,
		scope: {
			invitation: '='
		},
		templateUrl: './templates/snippets/mailgun-confirmation-status.html',
		replace: true,
		restrict: 'E',

		link: function($scope, element, attrs) { }
	}
})

.directive('invitationSubTable', function( USER_CATEGORIES, USER_ROLES ) {
	return {
		transclude: true,
		scope: {
			invitation: '='
		},
		templateUrl: './templates/snippets/invitation-sub-table.html',
		replace: true,
		restrict: 'E',

		link: function($scope, element, attrs) {
			var rolesLabels = {};

			angular.forEach( USER_CATEGORIES, function(cat) {
				rolesLabels[cat.category] = [];
				angular.forEach( USER_ROLES[cat.category], function(role) {
					rolesLabels[cat.category][role.role] = role.label;
				});
			});
			$scope.rolesLabels = rolesLabels;
		}
	}
})

.directive('invitationStatusSubTable', function( USER_CATEGORIES, USER_ROLES ) {
	return {
		transclude: true,
		scope: {
			invitation: '='
		},
		templateUrl: './templates/snippets/invitation-status-sub-table.html',
		replace: true,
		restrict: 'E',

		link: function($scope, element, attrs) {

		}
	}
})

.directive('invitationTransfersTable', function(  ) {
	return {
		transclude: true,
		scope: {
			invitationTransfers: '='
		},
		templateUrl: './templates/snippets/invitation-transfer-table.html',
		replace: true,
		restrict: 'E',

		link: function($scope, element, attrs) {

			$scope.transferOccupations = [];

		}
	}
})

.directive('hotelRoomsTable', function( ROOM_OCCUPATIONS ) {
	return {
		transclude: true,
		scope: {
			hotelRooms: '='
		},
		templateUrl: './templates/snippets/hotel-rooms-table.html',
		replace: true,
		restrict: 'E',

		link: function($scope, element, attrs) {

			$scope.roomOccupations = [];
			angular.forEach( ROOM_OCCUPATIONS, function(rt) {
				$scope.roomOccupations[ rt.occupation ] = rt.label;
			});

		}
	}
})

.directive('rankingStatus', function() {
	return {
		transclude: true,
		scope: {
			ranking: '='
		},
		templateUrl: './templates/snippets/ranking-status.html',
		replace: true,
		restrict: 'E',

		link: function($scope, element, attrs) { }
	}
})

.directive('preInvitationType', function() {
	return {
		transclude: true,
		scope: {
			invitation: '='
		},
		templateUrl: './templates/snippets/pre-invitation-type.html',
		replace: true,
		restrict: 'E',

		link: function($scope, element, attrs) { }
	}
});
